import { AutoComplete } from "primereact/autocomplete";
import React, { useEffect, useState } from "react";
import MaskedInput from "react-maskedinput";
// import Select from "react-select";
import { i18n } from "translate/i18n";
import { getRequest } from "utils/request";
import './style.css'
import ReCAPTCHA from "react-google-recaptcha";
import { cnpjMask } from "services/mask.js";
import { postRequest } from "utils/request";
import { addMonths, format } from "date-fns";
import { toast } from "react-toastify";
import { CircularProgress } from "@material-ui/core";
import { useHistory } from 'react-router-dom';
import logoImg from '../../assets/images/logo-omni.png';
import { tzList } from "utils/timezoneList";

class TrialCompany {
    name = '';
    nickName = '';
    CompanyCategoryId = 0;
    pending = false;
    site = null;
    document = '';
    responsibleName = '';
    responsibleEmail = '';
    responsibleCellPhone = '';
    Channels = [4,2,1];
    trialValidate = format(new Date(addMonths(new Date(), 1)), 'yyyy-MM-dd HH:mm:ss');
    trial = 1;
    skute = 3;
    timeZone = '';
}

class TrialUser {
    name = '';
    login = '';
    nickName = '';
    email = '';
    document = '';
    password = '';
    confirmPassword = '';
    language = 'pt-BR';
    UserTypeId = 8;
    timeZone = '';
}
  
export default function TrialAccount() {
    const [trialUser, setTrialUser] = useState(new TrialUser());
    const [trialCompany, setTrialCompany] = useState(new TrialCompany());
    const [disabled, setDisabled] = useState(false);
    const [disabledLogin, setDisabledLogin] = useState(false);
    const [listCategory, setListCategory] = useState([]);
    const [captcha, setCaptcha] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const history = useHistory();

    const getCategories = async (e) => {
        await getRequest(`/companiescategories?text=${e.query}&offset=${0}&limit=${1000}&onlyActive=1`)
            .then(function (response) {
                if(response.data) { 
                setListCategory(response.data);
            }
        })
    }

    const checkDocument = async () => {
        if(trialCompany.document.length === 18) {
            await getRequest(`/companies/document/isValid?document=${trialCompany.document}`)
            .then(e => {
                if(!e.success) {
                    setDisabled(true);
                } else {
                    setDisabled(false);
                }
            })
        } else {
            setDisabled(false)
        }
    }

    const checkLogin = async () => {
        if(trialUser.login.length > 4) {
            await getRequest(`/users/isLoginValid/${trialUser.login}`)
            .then(e => {
                if(!e.success) {
                    setDisabledLogin(true);
                } else {
                    setDisabledLogin(false);
                }
            })
        } else {
            setDisabledLogin(false)
        }
    }

    const ConfigMask = (data) => {
        let value;
        value = data.replace(/([^\d])+/gim, "");
        return value;
    };

    const handleCompanyInputChange = (e) => {
        const { name, value } = e.target;
        setTrialCompany({ ...trialCompany, [name]: value });
    }

    const handleUserInputChange = (e) => {
        const { name, value } = e.target;
        setTrialUser({ ...trialUser, [name]: value });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(trialUser.password !== trialUser.confirmPassword) {
            toast.error(i18n.t('passwordNotMatch'));
            return
        }
        if(trialCompany?.site?.length === 0) {
            trialCompany.site = null;
        }
        setLoading(true);
        postRequest(`/companies/trial?language=${localStorage.getItem('i18nextLng')}`, {
           ...trialCompany, 
           CompanyCategoryId: trialCompany.CompanyCategoryId.id,
        }).then(e => {
            if(e.success) {
                postRequest(`/users/staff/trial`, {
                    ...trialUser,
                    Companies: [e.data.id]
                }).then(r => {
                    setLoading(false)
                    history.push('/login')
                })
            } else {
                setLoading(false)
                history.push('/login')
            }
        })
    }

    useEffect(() => {
        getCategories('');
    }, []);

    return (
        <>
        <div className="trialaccount-header">
        
            {i18n.t('registerTrialAccount')}
            <img alt="logo" className="logo-header-trial" src={logoImg}></img>
        </div>
        {!loading ?
            <form
                className="trialaccount-container"
                onSubmit={(e) => handleSubmit(e)}
            >
                <h4>Cadastrar Empresa</h4>
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label>{i18n.t('socialReason')} *</label>
                        <input
                            type="text"
                            className="form-control"
                            value={trialCompany.name}
                            name="name"
                            maxLength={100}
                            required
                            onChange={handleCompanyInputChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label> {i18n.t('fantasy')} *</label>
                        <input
                            type="text"
                            className="form-control"
                            required
                            maxLength={100}
                            name="nickName"
                            value={trialCompany.nickName}
                            onChange={handleCompanyInputChange}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label>{i18n.t('registry')} *</label>
                        <input
                            type="text"
                            className="form-control"
                            data-reverse="true"
                            maxLength="18"
                            minLength="18"
                            required
                            name="document"
                            onBlur={checkDocument}
                            value={trialCompany.document}
                            onChange={(e) => setTrialCompany({...trialCompany, document: cnpjMask(e.target.value)})}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <label>{i18n.t('category')} *</label>
                            <AutoComplete 
                                value={trialCompany.CompanyCategoryId} 
                                suggestions={listCategory} 
                                completeMethod={getCategories} 
                                field="description" 
                                dropdown 
                                onChange={(e) => setTrialCompany({...trialCompany, CompanyCategoryId: e.value})} 
                            />
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-4" style={{paddingLeft: 0}}>
                        <label>{i18n.t('site')}</label>
                        <input
                            type="text"
                            className="form-control"
                            maxLength={255}
                            name="site"
                            value={trialCompany.site}
                            onChange={handleCompanyInputChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label> {i18n.t('timeZone')} *</label>
                        <select
                            className="form-control select2"
                            data-toggle="select2"
                            value={trialCompany.timeZone}
                            name="timeZone"
                            required
                            onChange={(e) => setTrialCompany({...trialCompany, timeZone: e.target.value})}
                        >
                            <option value="">{i18n.t('select')}</option>
                            {tzList.map((data, index) => (
                            <option key={index} value={data.value}>
                                {data.label}
                            </option>
                            ))}
                        </select>
                    </div>
                </div>
                <h4 style={{ marginTop: 10 }} className="header-title">
                    {i18n.t('contact')}
                </h4>
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label> {i18n.t('responsible')} *</label>
                        <input
                            type="text"
                            className="form-control"
                            required
                            maxLength={100}
                            name="responsibleName"
                            value={trialCompany.responsibleName}
                            onChange={handleCompanyInputChange}
                        />
                    </div>

                    <div className="form-group col-md-4">
                        <label>{i18n.t('phone')} *</label>
                        <MaskedInput
                            type="text"
                            className="form-control"
                            data-toggle="input-mask"
                            mask="(11) 11111-1111"
                            data-mask-format="(00) 00000-0000"
                            maxLength="15"
                            minLength="14"
                            required
                            name="responsibleCellPhone"
                            value={trialCompany.responsibleCellPhone}
                            onChange={handleCompanyInputChange}
                        />
                    </div>
                </div>
                <div style={{paddingLeft: 0}} className="form-group col-md-4">
                    <label>{i18n.t('email')} *</label>
                    <input
                        type="text"
                        className="form-control"
                        maxLength={100}
                        required
                        name="responsibleEmail"
                        value={trialCompany.responsibleEmail}
                        onChange={handleCompanyInputChange}
                    />
                </div>
                <h5>Dados do usuário de acesso</h5>
                <div className="form-row">
                    <div className="form-group col-md-4 mt-1">
                        <label>{i18n.t('login')} *</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Login"
                            maxLength={30}
                            minLength={5}
                            name="login"
                            style={{marginRight: 10}}
                            onBlur={checkLogin}
                            required
                            value={trialUser.login}
                            onChange={handleUserInputChange}
                        />
                        <label style={{marginTop: 10, width: 500}}>{i18n.t('loginSugest')}</label>
                        <label style={{width: 500}}>{i18n.t('loginExample')}</label>
                    </div>
                    <div className="form-group col-md-4">
                        <label style={{marginTop: 6}}> {i18n.t('timeZone')} *</label>
                        <select
                            className="form-control select2"
                            data-toggle="select2"
                            value={trialUser.timeZone}
                            name="timeZone"
                            required
                            onChange={(e) => setTrialUser({...trialUser, timeZone: e.target.value})}
                        >
                            <option value="">{i18n.t('select')}</option>
                            {tzList.map((data, index) => (
                            <option key={index} value={data.value}>
                                {data.label}
                            </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label>{i18n.t('name')} *</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nome"
                            required
                            maxLength={100}
                            name="name"
                            value={trialUser.name}
                            onChange={handleUserInputChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>{i18n.t('nickname')} *</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Apelido"
                            maxLength={100}
                            // disabled={!active}
                            required
                            name="nickName"
                            value={trialUser.nickName}
                            onChange={handleUserInputChange}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label>{i18n.t('document')} *</label>
                        <MaskedInput
                            mask="111.111.111-11"
                            type="text"
                            className="form-control"
                            // disabled={!active}
                            data-toggle="input-mask"
                            data-mask-format="000.000.000-00"
                            data-reverse="true"
                            maxLength="14"
                            minLength="14"
                            placeholder="000.000.000-00"
                            required
                            value={trialUser.document}
                            onChange={(value) =>
                                setTrialUser({...trialUser, document: ConfigMask(value.target.value)})
                            }
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>{i18n.t('email')} *</label>
                        <input
                            type="email"
                            id="example-email"
                            maxLength={100}
                            name="email"
                            className="form-control"
                            value={trialUser.email}
                            placeholder="exemplo@exemplo.com.br"
                            onChange={handleUserInputChange}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label>{i18n.t('initialPassword')} *</label>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            className="form-control"
                            placeholder="Senha Inicial"
                            name="password"
                            required
                            value={trialUser.password}
                            onChange={handleUserInputChange}
                        />
                        <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ position: 'absolute', top: 35, right: 15, cursor: "pointer"}}></i>
                    </div>
                    <div className="form-group col-md-4">
                        <label>{i18n.t('confirmPassword')} *</label>
                        <input
                            type={showConfirmPassword ? 'text' : 'password'}
                            className="form-control"
                            placeholder="Senha Inicial"
                            required
                            name="confirmPassword"
                            value={trialUser.confirmPassword}
                            onChange={handleUserInputChange}
                        />
                        <i className={showConfirmPassword ? "fas fa-eye-slash" : "fas fa-eye"}
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        style={{ position: 'absolute', top: 35, right: 15, cursor: "pointer"}}></i>
                    </div>
                </div>
                <ReCAPTCHA
                    sitekey="6LdPqRAcAAAAADJiDTh4MIdgLOyDvXPdG2STJI4M"
                    onChange={(e) => setCaptcha(true)}
                />
                <div
                    className="button-list mt-3 pull-right"
                    style={{width: '66.5%', display: 'flex', justifyContent: 'space-between'}}
                >   
                <div/>
                    <button disabled={!captcha || disabled || disabledLogin} type="submit" className="btn btn-outline-success" 
                    >
                        <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
                    </button>
                </div>
            </form>
            :
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh'}}>
                    <CircularProgress
                        className="loading-send-chat-client-page"
                        size={40}
                    />
                </div>
            }
        </>
    )
}